export default {
  vision_blog: "vision блог".toUpperCase(),
  stay_turned__: "Следите за всем, что происходит на Vision".toUpperCase(),
};
